(function () {
  function init(root) {
    var box = root.querySelector('[data-cbb-items]');
    if (!box) return;

    var ul = box.querySelector('ul');
    if (!ul) return;

    var items = ul.querySelectorAll('li');
    if (!items.length) return;

    items.forEach(function (li, idx) {
      if (li.querySelector('.cbb-li__icon')) return;

      var i = idx + 1;
      var iconVar = '--cbb-icon-' + i;

      var icon = document.createElement('span');
      icon.className = 'cbb-li__icon';
      icon.setAttribute('aria-hidden', 'true');

      var bg = getComputedStyle(box).getPropertyValue(iconVar).trim();
      if (bg) icon.style.backgroundImage = bg;

      li.insertBefore(icon, li.firstChild);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cbb-root]').forEach(init);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.matches('[data-cbb-root]')) init(t);
    else {
      var root = t.querySelector('[data-cbb-root]');
      if (root) init(root);
    }
  });
})();
(function () {
  function wrapText(li) {
    const strong = li.querySelector('strong');
    if (!strong) return;

    // знайти всі текстові вузли після <strong>
    const nodes = [];
    let foundStrong = false;

    li.childNodes.forEach(node => {
      if (node === strong) {
        foundStrong = true;
        return;
      }
      if (!foundStrong) return;

      // текст або inline-нода
      if (
        node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '' ||
        node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'SPAN'
      ) {
        nodes.push(node);
      }
    });

    if (!nodes.length) return;

    const span = document.createElement('span');
    span.className = 'cbb-li__text';

    nodes.forEach(n => span.appendChild(n));
    li.appendChild(span);
  }

  function init(root) {
    root.querySelectorAll('.cbb__rte li').forEach(wrapText);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cbb-root]').forEach(init);
  });

  document.addEventListener('shopify:section:load', e => {
    const root = e.target.querySelector('[data-cbb-root]');
    if (root) init(root);
  });
})();
